import React from 'react'
import { t } from '../../lang/index';

const UpdateSection = () => {
    const faq = t("home.updateSection.faq")
    const support = t("home.updateSection.support")

    return (
        <>
            {/* FAQ Section */}
            <section className="faq-section section">
                <div className="container">
                    <div className="faq-sec">
                        <div className="row justify-content-center">
                            <div className="col-xl-6 col-lg-10 text-center aos" data-aos="fade-up">
                                <div className="section-header text-center">
                                    <h2 className="mb-2">
                                        {t("home.updateSection.faq.title", { highlight: t("home.updateSection.faq.highlight") })}
                                    </h2>
                                    <p className="sub-title">{faq.subtitle}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 mx-auto">
                                <div className="accordion accordion-flush" id="accordionFaq">
                                    {faq.questions.map((q: any, idx: number) => (
                                        <div key={idx} className="accordion-item mb-3 pb-3 aos" data-aos="fade-up">
                                            <h2 className="accordion-header">
                                                <button
                                                    className={`accordion-button ${idx !== 0 ? 'collapsed' : ''}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#faq-collapse${idx}`}
                                                    aria-controls={`faq-collapse${idx}`}
                                                >
                                                    {q.question}
                                                </button>
                                            </h2>
                                            <div
                                                id={`faq-collapse${idx}`}
                                                className={`accordion-collapse collapse ${idx === 0 ? 'show' : ''}`}
                                                data-bs-parent="#accordionFaq"
                                            >
                                                <div className="accordion-body">
                                                    <p>{q.answer}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /FAQ Section */}

            {/* Support Section */}
            <section className="support-section bg-primary">
                <div className="horizontal-slide d-flex" data-direction="left" data-speed="slow">
                    <div className="slide-list d-flex">
                        {support.items.map((item: string, idx: number) => (
                            <div key={idx} className="support-item">
                                <h5>{item}</h5>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* /Support Section */}
        </>
    )
}

export default UpdateSection
